import { Component, Input } from '@angular/core';
import { MenuItem } from '../../../layouts/horizontaltopbar/menu.model';

@Component({
  selector: 'app-page-title',
  templateUrl: './pagetitle.component.html',
  styleUrls: ['./pagetitle.component.scss']
})
export class PagetitleComponent {

  @Input() breadcrumbItems: any;
  @Input() title: string;

  constructor() { }

  trackByItemId(index: number, item: MenuItem): number {
    return item.id;
  }

}
